export default __webpack_public_path__ + "static/image-05-330x330-654b3ae91f334e7dae02db0764c5fd0e.jpg";